/*
 *
 * parse location & setup baseUrl, language & country
 *
 */
export const basePath = (process.env.NODE_ENV === 'development')
  ? ''
  : '/pro'

// ${path}/language-country/
const re = new RegExp(`^(${basePath}/([a-z]{2})-([a-z]{2}))/`)

// parse current location path
const matches = window.location.pathname.match(re)

if (!matches) {
  throw new Error('Incorrect location path.')
}

export const baseUrl = matches[0]

export const country = matches[matches.length - 1]

export const language = matches[matches.length - 2]
